import React, { useState } from 'react';
import './Collapse.css';
import { useLanguage } from '../../contexts/LanguageContext';
import { translate } from '../../locales';

interface CollapseProps {
  title: React.ReactNode;
  onDelete: () => void;
  onSave?: () => void;
  children: React.ReactNode;
}

const Collapse: React.FC<CollapseProps> = ({ title, onDelete, onSave, children }) => {
  const { language } = useLanguage();
  const t = (key: any) => translate(key, language as 'en' | 'ua');
  const [open, setOpen] = useState(false);

  const handleHeaderClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // Prevent collapse toggle if delete button is clicked
    if ((e.target as HTMLElement).closest('.collapse-delete')) return;
    setOpen((prev) => !prev);
  };

  return (
    <div className={`collapse${open ? ' open' : ''}`}>
      <div className="collapse-header" onClick={handleHeaderClick}>
        <span className="collapse-title">{title}</span>
        <button className="collapse-delete" onClick={onDelete} type="button" title={t('businessSettings.deleteBusiness')} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
          <i className="bi bi-trash" style={{ fontSize: 18, color: '#dc3545' }}></i>
        </button>
      </div>
      <div className="collapse-content-wrapper" style={{ maxHeight: open ? 999 : 0 }}>
        <div className="collapse-content">
          {children}
          {open && onSave && (
            <div className="collapse-actions">
              <button className="btn-primary collapse-save-btn" onClick={() => { onSave(); setOpen(false); }} type="button">
                <i className="bi bi-check-circle"></i>
                {t('common.save')}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Collapse;
